import React from 'react';

// Passthrough wrapper — always renders content (guaranteed visible).
// Motion is handled elsewhere (hover states, floaty hero, marquee, gradients).
export default function Reveal({ children, delay = 0, className = '' }) {
  return (
    <div
      className={className}
      style={{ animation: `revealUp 0.6s cubic-bezier(0.22,1,0.36,1) both`, animationDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}
